<template>
  <v-footer padless absolute>
    <v-card class="flex" flat tile>
      <v-card-text class="teal py-2">
        <v-row no-gutters>
          <v-col cols="12" style="color:white">
            © European Palm Society {{ new Date().getFullYear() }} &nbsp; <router-link v-if="siteIsLive" to="/contact"
              style="color:white;align:right;">Contact Us</router-link>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>

export default {

  computed: {
    siteIsLive() {

      let siteIsLive = process.env.VUE_APP_LIVE

      return (siteIsLive != null && siteIsLive != "false");

    },
  }

};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>